/*
  Product gallery: round arrows at the two ends of the thumbnail row (tablets and desktop).
  - phones: the arrows scroll the photo slider by one photo
  - wider screens: the theme shows one photo at a time and changes it from the thumbnails,
    so the arrows click the next or previous thumbnail (all the theme's own behaviour stays: active thumbnail, live region, scrolling)
  The arrows are disabled on the first and last photo.
*/
if (!customElements.get('joyvo-gallery-arrows')) {
  customElements.define(
    'joyvo-gallery-arrows',
    class JoyvoGalleryArrows extends HTMLElement {
      connectedCallback() {
        this.gallery = this.closest('media-gallery');
        // the arrows sit in the thumbnail strip; the photo slider is the other slider component of the gallery
        this.sliderComponent = this.gallery && this.gallery.querySelector('slider-component:not(.thumbnail-slider)');
        if (!this.gallery || !this.sliderComponent) return;
        this.prev = this.querySelector('[data-direction="prev"]');
        this.next = this.querySelector('[data-direction="next"]');
        this.prev.addEventListener('click', () => this.move(-1));
        this.next.addEventListener('click', () => this.move(1));

        this.sliderComponent.addEventListener('slideChanged', () => this.update());
        const thumbnails = this.gallery.querySelector('[id^="GalleryThumbnails"]');
        if (thumbnails) new MutationObserver(() => this.update()).observe(thumbnails, { attributes: true, attributeFilter: ['aria-current'], subtree: true });
        // a new variant re-orders and hides photos
        const list = this.sliderComponent.querySelector('.slider');
        if (list) new MutationObserver(() => this.update()).observe(list, { childList: true, attributes: true, attributeFilter: ['class', 'hidden'] });
        window.addEventListener('resize', () => this.update());
        this.update();
      }

      thumbnailButtons() {
        return [...this.gallery.querySelectorAll('.thumbnail-list__item')]
          .filter((item) => item.offsetWidth > 0)
          .map((item) => item.querySelector('button'))
          .filter(Boolean);
      }

      slides() {
        return [...this.sliderComponent.querySelectorAll('.slider__slide')].filter((slide) => slide.offsetWidth > 0);
      }

      useThumbnails() {
        return window.matchMedia('(min-width: 750px)').matches && this.thumbnailButtons().length > 1;
      }

      position() {
        if (this.useThumbnails()) {
          const buttons = this.thumbnailButtons();
          const index = buttons.findIndex((button) => button.getAttribute('aria-current') === 'true');
          return { index: Math.max(0, index), total: buttons.length };
        }
        return { index: Math.max(0, (this.sliderComponent.currentPage || 1) - 1), total: this.slides().length };
      }

      move(direction) {
        const { index, total } = this.position();
        const target = index + direction;
        if (target < 0 || target >= total) return;
        if (this.useThumbnails()) this.thumbnailButtons()[target].click();
        else this.sliderComponent.slider.scrollTo({ left: this.slides()[target].offsetLeft, behavior: 'smooth' });
      }

      update() {
        const { index, total } = this.position();
        this.prev.disabled = index <= 0;
        this.next.disabled = index >= total - 1;
        this.hidden = total < 2;
      }
    }
  );
}
